import { useEffect, useState } from "react";
import PromoCode from "./PromoCode";
import { getPromocodes } from "../../../services/promocodes";
import { useCookies } from "react-cookie";

export default function PromoCodes({ showCopyMessage, setShowCopyMessage }) {
  const [promocodes, setPromocodes] = useState([]);
  const [cookie] = useCookies(["access_token"]);

  useEffect(() => {
    getPromocodes(cookie.access_token).then((res) => {
      const today = new Date();
      const filterByExpiration = res.filter(
        ({ expireAt }) => new Date(expireAt) > today
      );
      setPromocodes(filterByExpiration);
    });
  }, []);
  return (
    <div className="promo-codes">
      {promocodes?.length > 0 ? (
        promocodes?.map((promocode) => {
          return (
            <PromoCode
              key={promocode.id}
              promocode={promocode}
              showCopyMessage={showCopyMessage}
              setShowCopyMessage={setShowCopyMessage}
            ></PromoCode>
          );
        })
      ) : (
        <div className="no-promo-codes">
          <p>Няма намерени промо кодове</p>
        </div>
      )}
    </div>
  );
}
